export default __webpack_public_path__ + "static/media/tz.259f5860.svg";